import { AutoComplete } from "antd";
import React from "react";
import { Colors } from "../../config";

const SearchTextField = ({
  containerStyle,
  value,
  options,
  inputStyle,
  onSelect,
  onSearch,
  onChange,
  placeholder,
  allowClear = true,
  notFoundContent = true,
  size,
  labelClass,
  labeltext,
  className,
  ...props
}) => {

  return (
    <div style={containerStyle}>
      <label
        className={labelClass}
        style={{ color: Colors.DarkGray }}
      >
        {labeltext}
      </label>
      <AutoComplete
        allowClear={allowClear}
        className={className}
        value={value}
        notFoundContent={notFoundContent}
        options={options}
        style={inputStyle}
        onSelect={onSelect}
        onSearch={onSearch}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        {...props}
      />
    </div>
  );
};

export default SearchTextField;
